// @flow

import styled from 'styled-components';
import type { Theme } from '../../../../types';

export default styled<any, Theme>('div')`
  color: ${props => props.theme.review.default.ratingColor};
  text-align: center;
  text-transform: uppercase;
  font-size: .9rem;
  margin-top: .5rem;
`;
